import type { TweetResponseReferencedTweetTweetBasicInfoAllOf } from './tweetResponseReferencedTweetTweetBasicInfoAllOf';
import type { TweetResponseReferencedTweetTweetBasicInfoAllOfTwo } from './tweetResponseReferencedTweetTweetBasicInfoAllOfTwo';

export type TweetResponseReferencedTweetTweetBasicInfo = TweetResponseReferencedTweetTweetBasicInfoAllOf & TweetResponseReferencedTweetTweetBasicInfoAllOfTwo;
